import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';

const BrandCategoryLink = ({
  category,
  brand,
  children,
  showDefaultName,
  onClick,
}) => {
  const { linkTo } = useContext(AppContext);
  return (
    <Link
      to={linkTo('brandCategory', {
        ...category,
        brandId: brand.id,
      })}
      onClick={onClick}
    >
      {showDefaultName && `${brand.name} ${category.name}`}
      {children}
    </Link>
  );
};

const { number, node, shape, string, bool, func } = PropTypes;

BrandCategoryLink.propTypes = {
  category: shape({
    id: string.isRequired,
    name: string,
    pathName: string.isRequired,
  }).isRequired,
  brand: shape({
    id: number.isRequired,
    name: string,
  }).isRequired,
  showDefaultName: bool,
  children: node,
  onClick: func,
};

BrandCategoryLink.defaultProps = {
  showDefaultName: true,
  children: undefined,
  onClick: () => {},
};

export default memo(BrandCategoryLink);
